import { createSlice } from '@reduxjs/toolkit';

import { TUser } from '../../types/user';

const initialState: TUser = null;

/* istanbul ignore next */
const userSlice = createSlice<TUser, {}>({
  initialState,
  name: 'user',
  reducers: {},
});

export const { reducer: userReducer } = userSlice;
